var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-bar-wrapper",class:{ 'fold-active': _vm.isFold }},[_c('div',{staticClass:"button",style:({ backgroundImage: ("url(" + _vm.HamburgerButton + ")") }),on:{"click":_vm.folding}}),_vm._v(" "),_c('div',{staticClass:"title-wrapper"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fd1d202","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/components/page-template/header/HeaderBar.vue
// module id = null
// module chunks = 